//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('webSites', {
//        templateUrl: 'views/components/views/webSites/webSites.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['ttGridFactory', function (ttGridFactory) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            vm.model = {
//                gridReady: true
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: 'w_websites_grid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            })
//                .setToolbar({ wrapping: true })
//                .setLoadDataFunction({
//                    method: 3028,
//                    parameters: {}
//                });
            
//            // #endregion VARIABLES & DEFINITIONS

//        }]
//    });
//})();
